import { DialogTrigger } from "react-aria-components";
import type {
	DrawerButtonUmbBlockElementModel,
	DrawerButtonUmbBlockSettingsElementModel,
} from "#/_generated/umbraco/delivery-api/models";
import { cn } from "tailwind-variants";
import { Button } from "#/_packages/umbrella/features/button/components/button.tsx";
import { tryGetButtonVariant } from "#/_packages/umbrella/features/button/utils";
import HeaderDrawer from "#/_packages/umbrella/integrations/umbraco/components/ui/header-drawer/index..tsx";
import type { BlockItemProps } from "#/_packages/umbrella/integrations/umbraco/types";
import { toHoverItemCssClasses } from "#/_packages/umbrella/integrations/umbraco/utils/animation-utils.ts";
import {
	tryGetIntent,
	tryGetSize,
} from "#/_packages/umbrella/utils";

type DrawerButtonBlockProps = BlockItemProps & {
	content: DrawerButtonUmbBlockElementModel;
	settings: DrawerButtonUmbBlockSettingsElementModel;
};

export default function DrawerButtonUmbBlock({
	className,
	content,
	settings,
}: DrawerButtonBlockProps) {
	const hideLabel = content.properties?.hideTextLabel ?? false;
	const size =
		content.properties?.size === "fullWidth"
			? "fullWidth"
			: tryGetSize(content.properties?.size);
	const sharedProps = {
		size,
		intent: tryGetIntent(content.properties?.intentColor),
		variant: tryGetButtonVariant(content.properties?.typeVariant),
		displayBlock: content.properties?.displayBlock ?? false,
		hideLabel,
		className: cn(
			toHoverItemCssClasses(settings.properties?.animationHoverType),
			className,
		),
		id: settings.properties?.generatedId ?? content.id,
	};

	return (
		<DialogTrigger>
			<Button {...sharedProps}>
				<Button.Content
					spriteIcon={content.properties?.icon}
					iconPosition={content.properties?.iconPosition}
					label={content.properties?.textLabel ?? ""}
					hideLabel={hideLabel}
				/>
			</Button>
			<HeaderDrawer />
		</DialogTrigger>
	);
}
